<template>
    <div>
        <vue-apex-charts ref="chart" @dataPointSelection="dataPointSelectionHandler" height="400" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts
  },
  data() {
    return {
      chartOptions: {
        colors: ['#000000', '#FF0000'],
        chart: {
          stacked: false,
          type:"scatter",
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          }
        },
        labels: [],
        xaxis: {
          type: 'datetime'
        },
        yaxis: [
          {
            title: {
              text: this.$t('GradeControl.Grade')
            },
            min: 0
          }
        ],
        tooltip: {
          shared: false,
          intersect: true,
          custom({ seriesIndex, dataPointIndex, w}) {
            let s  = '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">Infos</div>' + 
              '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">' + 
                '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                    '<div class="apexcharts-tooltip-y-group">' + 
                      '<span class="apexcharts-tooltip-text-label">Grade : </span>' + 
                      '<span class="apexcharts-tooltip-text-value">' + w.config.series[seriesIndex].data[dataPointIndex].y.toFixed(4) + '</span>' +
                    '</div>' + 
                    '<div class="apexcharts-tooltip-z-group">' + 
                      '<span class="apexcharts-tooltip-text-z-label"></span>' + 
                      '<span class="apexcharts-tooltip-text-z-value"></span>' +
                    '</div>' + 
                  '</div>' + 
              '</div>';
            if (w.config.series[seriesIndex].data[dataPointIndex].roundNumber !== null) {
              s += '<div class="apexcharts-tooltip-series-group" style="order: 2; display: flex;">' + 
                  '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                      '<div class="apexcharts-tooltip-y-group">' + 
                        '<span class="apexcharts-tooltip-text-label">Round Number : </span>' + 
                        '<span class="apexcharts-tooltip-text-value">' + w.config.series[seriesIndex].data[dataPointIndex].roundNumber + '</span>' +
                      '</div>' + 
                      '<div class="apexcharts-tooltip-z-group">' + 
                        '<span class="apexcharts-tooltip-text-z-label"></span>' + 
                        '<span class="apexcharts-tooltip-text-z-value"></span>' +
                      '</div>' + 
                    '</div>' + 
                '</div>'
            }
            return (s);
          }
        }
      },
      series: []
    };
  },
  
  methods: {
    defineDiagramSettings() {
      const dates = this.$store.state.gradeControl.samples.map(m => m.extractionDate).filter((value, index, self) => self.indexOf(value) === index);
      dates.sort((a, b) => { return new Date(b) - new Date(a) });
      const labels = [];
      const includedGrades = [];
      const excludedGrades = [];
      dates.forEach(date => {
        labels.push(this.$options.filters.toDate(date))
        const results = this.$store.state.gradeControl.samples.filter(m => m.extractionDate === date && m.goldGrade !== null);
        if (typeof results !== 'undefined') {
          results.forEach(result => {
            if (result.isExcluded || result.isGoldExcluded) {
              excludedGrades.push({x: date, y: this.$systemUnits.convertGrade(result.goldGrade), roundNumber : result.roundNumber})
            } else {
              includedGrades.push({x: date, y: this.$systemUnits.convertGrade(result.goldGrade), roundNumber : result.roundNumber})
            }
          });
        }
      });

      const includedSerie = {
        name:  this.$t('GradeControl.Sample.IncludedSamples'),
        data: includedGrades
      }

      const excludedSerie = {
        name:  this.$t('GradeControl.Sample.ExcludedSamples'),
        data: excludedGrades
      }

      this.series = [includedSerie, excludedSerie];
    
      this.$refs.chart.updateOptions({ labels });
    },
    dataPointSelectionHandler(e, chartContext, config) {
      const samplePoint = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
      const extractionDate = samplePoint[0];
      const grade = samplePoint[1];
      const sample = this.$store.state.gradeControl.samples.find(m => m.extractionDate === extractionDate && m.goldGrade === grade);
        
      if (typeof sample !== 'undefined') {
        sample.isGoldExcluded = !sample.isGoldExcluded;
        this.$emit("onUpdateSample", sample);
      }
    }
  }
};
</script>
